import React, { useState } from 'react'
import {Box, Text, Textarea, Button, UnorderedList, ListItem, ListIcon, List} from '@chakra-ui/react'
import {MdCheckCircle, MdNotInterested} from 'react-icons/md'
import { Ptext } from '../../../componentsF/Chakra3F/ChakraF.jsx'


const GoodLi = ({children}) => {
  return <ListItem>
    <ListIcon {...{as: MdCheckCircle, color: 'green.500'}} />
    {children}
  </ListItem>
}

const BadLi = ({children}) => {
  return <ListItem>
    <ListIcon {...{as: MdNotInterested, color: 'red.500'}} />
    {children}
  </ListItem>
}

export const InitialDescription = ({fontSize}) => {
  const [showIdeas, setShowIdeas] = useState(false)
  const onClick = () => setShowIdeas(!showIdeas)
  const color = 'blue.200'
  const linkProps = {onClick, color, cursor: 'pointer'}
  return <>
    <Ptext {...{fontSize, mt: 4, mb: 4}}>Describe an interesting scene:</Ptext>
    {!showIdeas && <Ptext {...{...linkProps, my: 2}}>(ideas)</Ptext>}
    {showIdeas && <Box {...{fontSize: 'md', my: 2}}>
      <Ptext {...linkProps}>(hide)</Ptext>
      <List>
        <GoodLi>Santa vs Jesus eating contest</GoodLi>
        <GoodLi>Dolphins having a tea party</GoodLi>
        <GoodLi>A pushy door to door salesman</GoodLi>
        <GoodLi>A pirate astronaut</GoodLi>
        <BadLi>A turkey</BadLi>
        <BadLi>An apple</BadLi>
        <BadLi>A christmas tree</BadLi>
      </List>
    </Box>}
  </>
}